module.exports = __webpack_public_path__ + "img/corporateCulture6.0bc6a2a7.png";